/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid'
import { useTranslation } from 'react-i18next'

interface UiTableColumnSearchToggleProps {
    onClick: () => void
    isActive?: boolean
    isOpen?: boolean
}

const UiTableColumnSearchToggle: React.FC<UiTableColumnSearchToggleProps> = ({
    onClick,
    isActive,
    isOpen,
}) => {
    const { t } = useTranslation()
    return (
        <button
            type="button"
            className={clsx(
                'UiTableColumnSearchToggle',
                'p-0.5 rounded transition-colors',
                isActive || isOpen
                    ? 'text-blue-500 bg-blue-50 dark:bg-blue-900/20'
                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-500 dark:hover:bg-gray-800'
            )}
            onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onClick()
            }}
            title={t('Search')}
        >
            <MagnifyingGlassIcon className="w-4 h-4" />
        </button>
    )
}

export default UiTableColumnSearchToggle
